import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

// Renders a real, scannable barcode onto a canvas using JsBarcode.
// Supported `type`: CODE128 (default fallback), EAN13, UPC, CUSTOM (-> CODE128)
const FORMAT_MAP = {
  CODE128: "CODE128",
  EAN13: "EAN13",
  UPC: "UPC",
  CUSTOM: "CODE128",
};

const BarcodeCanvas = ({ value, type = "CODE128", height = 40, width = 2, displayValue = true, style }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || !value) return;
    const format = FORMAT_MAP[type] || "CODE128";
    try {
      JsBarcode(canvasRef.current, value, {
        format,
        height,
        width,
        displayValue,
        margin: 4,
        fontSize: 14,
      });
    } catch (err) {
      // Invalid value for the selected format (e.g. non-numeric EAN13) -> fall back to CODE128
      try {
        JsBarcode(canvasRef.current, value, {
          format: "CODE128",
          height,
          width,
          displayValue,
          margin: 4,
          fontSize: 14,
        });
      } catch (e) {
        // ignore - leave canvas blank
      }
    }
  }, [value, type, height, width, displayValue]);

  return <canvas ref={canvasRef} style={{ maxWidth: "100%", ...style }} />;
};

export default BarcodeCanvas;
